import { IconButton } from "@medoma/components/Button/Button";
import type { LinkProps } from "react-router";
import ArrowLeftIcon from "@medoma/components/icons/ArrowLeftIcon";
import CrossIcon from "@medoma/components/icons/CrossIcon";
import { useLingui } from "@lingui/react/macro";
import styles from "./NavigationButtons.module.scss";

const BackButton = ({
  ariaLabel,
  ...props
}: { ariaLabel?: string } & (
  | { navigateBack: () => void }
  | { asLinkTo: LinkProps["to"]; relative?: LinkProps["relative"] }
)) => {
  const { t } = useLingui();
  const label = ariaLabel || t`Tillbaka`;

  const navigationProps =
    "navigateBack" in props ? { onClick: props.navigateBack } : props;

  return (
    <IconButton aria-label={label} {...navigationProps}>
      <ArrowLeftIcon />
    </IconButton>
  );
};

const CloseButton = ({ close }: { close: () => void }) => {
  const { t } = useLingui();

  return (
    <div className={styles.button}>
      <IconButton aria-label={t`Stäng`} onClick={close}>
        <CrossIcon />
      </IconButton>
    </div>
  );
};

export { BackButton, CloseButton };
